import React from 'react'
import type { MobilePage as MobilePageData } from 'api/api.types'
import { parseHtml } from 'utils/htmlParserWithCustomLinks'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { Salons } from 'components/PageElements/Salons/Salons'
import { Picture } from 'components/Utility/Media/Picture'
import styles from './MobilePage.module.scss'

type MobilePageProps = {
  page: MobilePageData,
}

/** The mobile app page with store links */
export const MobilePage: React.FC<MobilePageProps> = ({ page }) => {
  const vars = page.templateVars.pageVars
  return <div className={styles.container}>
    <div className={styles.contentContainer}>
      <div className={styles.textContainer}>
        <div className={styles.content}>
          <h1 className={styles.title}>{page.title}</h1>
          <article className={'text-content'}>{parseHtml(vars.content || '')}</article>
        </div>
        <div className={styles.imageContainer}>
          {vars.image && (
            <Picture
              className={styles.img}
              image={vars.image.image}
              desktopType={'original-webp'}
              mobileType={'original-webp'}
              alt={vars.image.type === 'image' ? vars.image.imageAlt : undefined}
            />
          )}
        </div>
      </div>
      <div className={styles.links}>
        <a href={vars.appstore} target={'_blank'} rel="noopener noreferrer">
          <AppButton className={styles.MobileBtns}>Apple App Store</AppButton>
        </a>
        <a href={vars.googleplay} target={'_blank'} rel="noopener noreferrer">
          <AppButton className={styles.MobileBtns}>Google Play</AppButton>
        </a>
      </div>
    </div>
    <div className={styles.map}>
      <Salons withCityTitle />
    </div>
  </div>
}
